import { apiClient } from '@/config/api';
import { ApiResponse } from '@/types/status';

export interface ImageItem {
    _id: string;
    url: string;
    alt?: string;
    width?: number;
    height?: number;
    caption?: string;
    linkImage?: string;
    title?: string;
    rel?: 'nofollow' | 'noreferrer' | 'noopener' | 'sponsored' | 'ugc';
    target?: '_self' | '_blank' | '_parent' | '_top';
    filename: string;
    originalName: string;
    path: string;
    size: number;
    mimeType: string;
    format?: string;
    uploadedBy?: { _id: string; username: string; name?: string; email?: string } | string;
    createdAt: string;
    updatedAt: string;
}

export interface ImageListResponse {
    images: ImageItem[];
    pagination: { page: number; limit: number; total: number; totalPages: number };
}

export interface CreateImageDto {
    url: string;
    alt?: string;
    caption?: string;
    linkImage?: string;
    title?: string;
    rel?: ImageItem['rel'];
    target?: ImageItem['target'];
}

export interface UpdateImageDto extends Partial<CreateImageDto> { }

export interface UploadImageDto extends Omit<CreateImageDto, 'url'> { }

const IMAGE_ENDPOINTS = {
    BASE: '/images',
    UPLOAD: '/images/upload',
    CREATE_FROM_URL: '/images/create-from-url',
};

export const imageService = {
    async upload(file: File, data?: UploadImageDto): Promise<ApiResponse<ImageItem>> {
        const form = new FormData();
        form.append('image', file);
        if (data) {
            Object.entries(data).forEach(([k, v]) => {
                if (v !== undefined && v !== null) form.append(k, String(v));
            });
        }
        return apiClient.post(IMAGE_ENDPOINTS.UPLOAD, form);
    },

    async createFromUrl(payload: CreateImageDto): Promise<ApiResponse<ImageItem>> {
        return apiClient.post(IMAGE_ENDPOINTS.CREATE_FROM_URL, payload);
    },

    async list(params: { page?: number; limit?: number; search?: string }): Promise<ApiResponse<ImageListResponse>> {
        return apiClient.get(IMAGE_ENDPOINTS.BASE, params as any);
    },

    async getById(id: string): Promise<ApiResponse<ImageItem>> {
        return apiClient.get(`${IMAGE_ENDPOINTS.BASE}/${id}`);
    },

    async update(id: string, data: UpdateImageDto): Promise<ApiResponse<ImageItem>> {
        return apiClient.put(`${IMAGE_ENDPOINTS.BASE}/${id}`, data);
    },

    async remove(id: string): Promise<ApiResponse<any>> {
        return apiClient.delete(`${IMAGE_ENDPOINTS.BASE}/${id}`);
    },
};


